import { BrowserPrint } from "./BrowserPrint-3.1.250.min.js";
import { ZebraPrinter } from "../../data/protocols/zebra-printer/zebra-printer";
import { PrinterNotFoundError } from "../errors/label-printer/PrinterNotFoundError";

export class ZebraLabelPrinter implements ZebraPrinter {
  async print(
    zplCode: string,
    errorCallback?: (error: Error) => void
  ): Promise<void> {
    BrowserPrint.getDefaultDevice(
      "printer",
      async function (device: any) {
        device.send(zplCode, undefined, () => {
          errorCallback && errorCallback(new PrinterNotFoundError());
        });
      },
      errorCallback
    );
  }
}
